app.service('productTabAccessories',function(console, productCardConfig, cartManager, log) {
	var $self, $accessoriesGroupsBox, $accessoriesList, $addToCart;
	var currentGroup;

	function scrollActiveGroupTabIntoView() {
		const $activeTab = $self.find('.js-category-tab.is-active');

		if (!$activeTab.length) return false;

		const ELEMENT_PADDING_LEFT = 15;
		const scrollLeft = $activeTab.offset().left - ELEMENT_PADDING_LEFT;

		$accessoriesGroupsBox.scrollLeft(scrollLeft);
	}

	function loadSuccess(html){
		console.log('ZAŁADOWANIE ZAKŁADKI: AKCESORIA');
		$self.html(html);
		setElements();
		setEvents();
		$accessoriesList.removeClass('loading');
		scrollActiveGroupTabIntoView();

		if(currentGroup !== 0){
			$.scrollTo($self ,100);
		}
		checkCart();
	}
	function loadError(){
		console.log('BŁĄD ŁADOWANIA ZAKŁADKI');
		$self.html('<div class="tab-error">Wystąpił błąd ładowania zakładki. Prosimy spróbować później</div>');
		$accessoriesList.removeClass('loading');
	}
	function checkCart() {
		cartManager.checkRelatedProducts();
	}
	function load(groupName){
		groupName = groupName || 0;
		if($self.length && groupName!=currentGroup){
			if(groupName !== 0){
				$accessoriesList.addClass('loading');
			}
			currentGroup = groupName;
			var config=productCardConfig.getData();
			var data={
				nodeid:config.nodeId,
				preview:config.preview,
				showAll:true,
				'group-id':groupName,
				'product-link-name':config.linkName,
				outletCategoryId: config.activeOutletCategory
			};
			$.ajax({
				url:'/product-card-access.ltr',
				data:data,
				success:function(html){
					loadSuccess(html);
				},
				error:function(){
					loadError();
				}
			});
		}
	}
	function setEvents(){
		$accessoriesGroupsBox.on('click', '.js-category-tab', function() {
			load($(this).data('group'));
			UA.pageInteraction('Akcesoria', 'Wybór grupy akcesoryjnej - ' + $(this).text().trim());
		});
		$addToCart.on('click',function(){
			if($(this).is(':checked')) {
				addAccessoryToCart($(this).val(), $(this).data('plu'));
				UA.doubleClick($(this).data('plu'),'dc-acc-tocart-kp');
			} else {
				removeAccessoryFromCart($(this).val());
			}
		});
		$(document).on('cartReady', function(){
			checkCart();
		});
	}
	function addAccessoryToCart(value, plu) {
		cartManager.simpleAddProduct({
			addedFrom:'ACCESS_CARD',
			productId:value
		}, () => {
			log.recommendationsForAWS({
				productPlu: plu,
				eventCategory: 'KP',
				eventAction: 'Dodanie akcesoria'
			});
		});
	}
	function removeAccessoryFromCart(value) {
		cartManager.removeProduct({
			productId:value
		});
	}
	function setElements(){
		$self=$('#accessories');
		$accessoriesGroupsBox = $('.js-accessories-groups', $self);
		$accessoriesList = $('.js-accessories-list', $self);
		$addToCart = $('.js-add-accessory-to-cart-checkbox', $self);
	}
	function init(){
		setElements();
		setEvents();
	}
	return {
		init:init
	};
});
